<div class="app-sample-theme-page mt-50">
  <div class="container">
    <table style="width:100%" class="text-center mt-40">
      <tr>
        <th>Variable Name</th>
        <th>Color code</th>
        <th>Color</th>
      </tr>
      <tr>
        <td>$primary-theme-color1</td>
        <td>{{themeColors['samplePrimaryTheme']}}</td>
        <td class="primary-theme"></td>
      </tr>
      <tr>
        <td>$secondary-theme-color2</td>
        <td>{{themeColors['sampleSecondaryTheme']}}</td>
        <td class="secondary-theme"></td>
      </tr>
      <tr>
        <td>$tertiary-theme-color3</td>
        <td>{{themeColors['sampleTertiaryTheme']}}</td>
        <td class="tertiary-theme"></td>
      </tr>
      <tr>
        <td>$quaternary-theme-color4</td>
        <td>{{themeColors['sampleQuaternaryTheme']}}</td>
        <td class="quaternary-theme"></td>
      </tr>
      <tr>
        <td>$pentagon-theme-color5</td>
        <td>{{themeColors['samplePentanaryTheme']}}</td>
        <td class="pentagon-theme"></td>
      </tr>
      <tr>
        <td>$hexagon-theme-color6</td>
        <td>{{themeColors['sampleHexonaryTheme']}}</td>
        <td class="hexagon-theme"></td>
      </tr>
      <tr>
        <td>$heptagon-theme-color7</td>
        <td>{{themeColors['sampleHeptanaryTheme']}}</td>
        <td class="heptagon-theme"></td>
      </tr>
      <tr>
        <td>$septanary-bg-color</td>
        <td>{{themeColors['sampleSeptanaryTheme']}}</td>
        <td class="septanary-bg"></td>
      </tr>
      <tr>
        <td>$octagon-bg-color</td>
        <td>{{themeColors['sampleOctanaryTheme']}}</td>
        <td class="octagon-bg"></td>
      </tr>
      <tr>
        <td>$nenone-bg-color</td>
        <td>{{themeColors['sampleNonaryTheme']}}</td>
        <td class="nonagon-bg"></td>
      </tr>
    </table>
    <table style="width:100%" class="text-center mt-40">
      <tr>
        <th>Set-1</th>
        <th>$primary-bg-color<br>Note: Light background, dark font color</th>
        <td class="primary-bg">
          <span class="primary-font2 pb-2">$primary-bg-font-color2</span><br>
          <span class="primary-font3 pb-2">$primary-bg-font-color3</span><br>
          <span class="primary-font4 pb-2">$primary-bg-font-color4</span><br>
          <span class="primary-font7 pb-2">$primary-bg-font-color7</span><br>
          <span class="primary-font8 pb-2">$primary-bg-font-color8</span><br>
          <span class="bg-note">Note:Background color is $primary-bg-color</span>
        </td>
      </tr>
      <tr>
        <th>Set-2</th>
        <th>$secondary-bg-color<br>Note: Dark background, light font color</th>
        <td class="secondary-bg">
          <span class="secondary-font1 pb-2">$secondary-bg-font-color1</span><br>
          <span class="secondary-font2 pb-2">$secondary-bg-font-color2</span><br>
          <span class="secondary-font4 pb-2">$secondary-bg-font-color4</span><br>
          <span class="secondary-font6 pb-2">$secondary-bg-font-color6</span><br>
          <span class="secondary-font8 pb-2">$secondary-bg-font-color8</span><br>
          <span class="secondary-font9 pb-2">$secondary-bg-font-color9</span><br>
          <span class="bg-note">Note:Background color is $secondary-bg-color</span>
        </td>
      </tr>
      <tr>
        <th>Set-3</th>
        <th>$tertiary-bg-color<br>Note: Light background, dark font color</th>
        <td class="tertiary-bg">
          <span class="tertiary-font1 pb-2">$tertiary-bg-font-color1</span><br>
          <span class="tertiary-font2 pb-2">$tertiary-bg-font-color2</span><br>
          <span class="tertiary-font3 pb-2">$tertiary-bg-font-color3</span><br>
          <span class="tertiary-font5 pb-2">$tertiary-bg-font-color5</span><br>
          <span class="tertiary-font6 pb-2">$tertiary-bg-font-color6</span><br>
          <span class="tertiary-font7 pb-2">$tertiary-bg-font-color7</span><br>
          <span class="tertiary-font8 pb-2">$tertiary-bg-font-color8</span><br>
          <span class="tertiary-font10 pb-2">$tertiary-bg-font-color10</span><br>
          <span class="bg-note">Note:Background color is $tertiary-bg-color</span>
        </td>
      </tr>
      <tr>
        <th>Set-4</th>
        <th>$quaternary-bg-color<br>Note: Light background, dark font color</th>
        <td class="quaternary-bg">
          <span class="quaternary-font1 pb-2">$quaternary-bg-font-color1</span><br>
          <span class="quaternary-font3 pb-2">$quaternary-bg-font-color3</span><br>
          <span class="quaternary-font4 pb-2">$quaternary-bg-font-color4</span><br>
          <span class="bg-note">Note:Background color is $quaternary-bg-color</span>
        </td>
      </tr>
      <tr>
        <th>Set-5</th>
        <th>$pentagon-bg-color<br>Note: Light background, dark font color</th>
        <td class="pentanary-bg">
          <span class="pentanary-font1 pb-2">$pentagon-bg-font-color1</span><br>
          <span class="pentanary-font3 pb-2">$pentagon-bg-font-color3</span><br>
          <span class="bg-note">Note:Background color is $pentagon-bg-color</span>
        </td>
      </tr>
      <tr>
        <th>Set-6</th>
        <th>$hexanaray-bg-color<br>Note: Dark background, light font color</th>
        <td class="hexanaray-bg">
          <span class="hexanary-font1 pb-2">$hexanary-bg-font-color1</span><br>
          <span class="bg-note">Note:Background color is $hexanaray-bg-color</span>
        </td>
      </tr>
      <!-- <tr>
        <th>Set-7</th>
        <th>$septanary-bg-color<br>Note: Light background, dark font color</th>
        <td class="heptagon-theme">
          <span class="septanary-font1 pb-2">$septanary-bg-font-color</span><br>
          <span class="bg-note">Note:Background color is $septanary-bg-color</span>
        </td>
      </tr> -->
    </table>
    <table style="width:100%" class="text-center mt-40 mb-40">
      <tr>
        <th>primary-bg-button</th>
        <th class="primary-bg">
          <button mat-flat-button class="flat-primary-button secondary-bg-button mt-10 mb-10">
            Button
          </button>
        </th>
      </tr>
      <tr>
        <th>primary-bg-btn1</th>
        <th class="primary-bg">
          <button mat-flat-button class="flat-primary-button secondary-bg-btn1 mt-10 mb-10">
            Button
          </button>
        </th>
      </tr>
      <tr>
        <th>secondary-bg-button</th>
        <th class="secondary-bg"> 
          <button mat-flat-button class="flat-primary-button secondary-bg-button mt-10 mb-10">
            Button
          </button>
        </th>
      </tr>
      <tr>
        <th>secondary-bg-btn1</th>
        <th class="secondary-bg"> 
          <button mat-flat-button class="flat-primary-button secondary-bg-btn1 mt-10 mb-10">
            Button
          </button>
        </th>
      </tr>
      <tr>
        <th>tertiary-bg-button</th>
        <th class="tertiary-bg">
          <button mat-flat-button class="flat-primary-button secondary-bg-button mt-10 mb-10">
            Button
          </button>
        </th>
      </tr>
      <tr>
        <th>tertiary-bg-btn1</th>
        <th class="tertiary-bg"> 
          <button mat-flat-button class="flat-primary-button secondary-bg-btn1 mt-10 mb-10">
            Button
          </button>
        </th>
      </tr>
    </table>
  </div>
</div>